module.exports = __webpack_public_path__ + "static/media/Standing Ant 01.c99ef461.png";